<script lang="ts">
    import IconImg from "./IconImg.svelte";
    import mail from "../icons/MailIcon.svelte";
    export let text: string;
</script>

<a class="icon-link" href="mailto:{text}">
    <IconImg svg={mail} />
    {text}
</a>

<style lang="scss">
    .icon-link {
        height: 1em;
    }
</style>
